import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";

export const NewSearchWidgetEntitiesSectionTitle = observer(({controller, listModel, hasRecentSearchesItems}) => {
  const {terms, config} = controller;
  const {source} = config;
  const {SELECTIONS_MENU_SEARCH_BOX_CLEAR} = terms;

  const clearProps = {
    className: classNames(styles.clear_button),
    onClick: () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onClearRecent, {source})
  }

  return (
    <div className={classNames(styles.entities_title, {[styles.title_and_clear]: hasRecentSearchesItems})}>
      {listModel?.title}
      {
        hasRecentSearchesItems ? <div {...clearProps}>{SELECTIONS_MENU_SEARCH_BOX_CLEAR}</div> : null
      }
    </div>
  )
});
